import { useInitializeDatadog } from "./useInitializeDatadog";
import { useInitializeSegment } from "./useInitializeSegment";

export function useInitializeMonitoring() {
  useInitializeDatadog();
  useInitializeSegment();
}
